import React, { useState, useEffect, useContext } from "react";
import PontajItem from "./PontajItem";
import {
  getTehnicianPontajeService,
  getUserRezumatPontajeService,
} from "../backend/PontajeService";
import { UserContext } from "../context/UserContext";

const PontajTehnician = ({ user }) => {
  const [pontaje, setPontaje] = useState([]);
  const [triggerPontaje, setTriggerPontaje] = useState(false);
  const [pontajeRezumat, setPontajeRezumat] = useState();
  const [pageSize, setPageSize] = useState(30);
  const [pageNumber, setPageNumber] = useState(1);
  const { isAdmin } = useContext(UserContext);
  const [canTriggerScroll, setCanTriggerScroll] = useState(true);

  const getPontajeUser = async () => {
    try {
      const result = await getTehnicianPontajeService(
        user,
        pageSize,
        pageNumber
      );
      const updatedPontaje = pontaje.concat(result).sort((a, b) => new Date(b.date) - new Date(a.date));
      setPontaje(updatedPontaje);
    } catch (err) {
      console.error(err);
    }
  };

  const getRezumatPontaje = async () => {
    try {
      const result = await getUserRezumatPontajeService(user);
      setPontajeRezumat(result);
    } catch (err) {
      console.error(err);
    }
  };

  const refreshPontaje = () => {
    setTriggerPontaje(!triggerPontaje);
  };

  useEffect(() => {
    if (user && pontaje.length > 0) {
      setPontaje([]);
    }
  }, [triggerPontaje]);

  useEffect(() => {
    if (user) getPontajeUser();
  }, [pageNumber, pageSize]);

  useEffect(() => {
    let timeout;
    if (user) {
      setCanTriggerScroll(false);
      timeout = setTimeout(() => setCanTriggerScroll(true), 500);
      refreshPontaje();
      getRezumatPontaje();
    }
    return () => {
      clearTimeout(timeout);
    }
  }, [user]);

  useEffect(() => {
    if (pontaje.length === 0) {
      if (pageNumber > 1) {
        setPageNumber(1);
      }
      else {
        getPontajeUser();
      }
    }
  }, [pontaje]);
  return (
    <div>
      <div
        onScroll={(e) => {
          if (!canTriggerScroll) return;
          const bottom =
            e.target.scrollHeight - e.target.scrollTop ===
            e.target.clientHeight;
          if (bottom && pontaje.length > 0) {
            setPageNumber(pageNumber + 1);
          }
        }}
        className="tab_pontaje_tehnician"
      >
        {pontaje.map((pontaj, index) => (
          <PontajItem
            key={index}
            pontaj={pontaj}
            refreshPontaje={() => { setPageNumber(1); refreshPontaje(); }}
          />
        ))}
      </div>
    </div>
  );
};

export default PontajTehnician;
